import React from 'react';
import { useTranslation } from '../../i18n/i18n';
import './Logo.scss';

interface LogoProps {
  size?: number;
  textSize?: number;
}

const Logo = ({ size = 30, textSize = 20 }: LogoProps) => {
  const { t } = useTranslation('common');
  return (
    <div className="Logo">
      <svg width={size} height={size} viewBox="0 0 36 36" fill="none" aria-hidden="true">
        <rect x="2" y="8" width="20" height="20" rx="5" stroke="#FFFFFF" strokeWidth="2.5" />
        <rect x="14" y="8" width="20" height="20" rx="5" stroke="#3DA9FC" strokeWidth="2.5" />
      </svg>
      <span className="Logo__text" style={{ fontSize: textSize }}>
        {t('brand')}
      </span>
    </div>
  );
};

export default Logo;
